module.exports = __webpack_public_path__ + "img/emoji_53.040ce183.png";